import { gql } from "@apollo/client";
import StripePlanFields from "~/lib/queries/fragments/StripePlanFields";

export default gql`
  query AvailablePlans {
    availablePlans {
      _id
      name
      displayName
      tier
      isSelectable
      stripePlanId
      limits {
        teamMembers
        products
        enrichedProducts
        groups
        groupInvitations
        sharingPage
        projectsPerMonth
        productTags
        enrichedProfile
      }
      stripePlan {
        ...StripePlanFields
      }
    }
  }

  ${StripePlanFields}
`;
